import { BASE_URL } from 'configs/app-global';
import getImage from 'helpers/getImage';

/** Full URL for gallery/storage asset preview. */
export function resolveGalleryAssetUrl(path) {
  if (path == null || String(path).trim() === '') return '';
  const s = String(path).trim();
  if (
    s.startsWith('http://') ||
    s.startsWith('https://') ||
    s.startsWith('blob:') ||
    s.startsWith('data:')
  ) {
    return s;
  }
  const base = BASE_URL.replace(/\/+$/, '');
  const clean = s.replace(/^\/+/, '');
  if (clean.startsWith('storage/')) return `${base}/${clean}`;
  return `${base}/storage/${clean}`;
}

/** Resolve extra value `img` for display (thumbnail, select options, order lines). */
export function extraValueImgSrc(img) {
  if (img == null || String(img).trim() === '') return null;
  const resolved = getImage(img);
  if (
    resolved &&
    !resolved.startsWith('http://') &&
    !resolved.startsWith('https://') &&
    !resolved.startsWith('blob:') &&
    !resolved.startsWith('data:')
  ) {
    return resolveGalleryAssetUrl(resolved);
  }
  return resolved;
}

/** Map gallery upload field or stored path to API `img` payload (full URL or storage path). */
export function extraValueImgPayload(imgField) {
  if (imgField === '' || imgField === null) return '';
  if (!imgField) return undefined;
  const name =
    typeof imgField === 'object'
      ? imgField.name ?? imgField.url ?? imgField.title
      : imgField;
  if (name == null || name === '') return undefined;
  const s = String(name);
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  return `${BASE_URL.replace(/\/+$/, '')}/storage/${s.replace(/^\/+/, '')}`;
}

/** Ant Design Upload / ImageUploadSingle field shape for edit preview. */
export function extraValueImgToUploadField(img) {
  if (img == null || String(img).trim() === '') return null;
  const src = extraValueImgSrc(img);
  return {
    uid: String(img),
    name: String(img),
    url: src,
    status: 'done',
  };
}
